/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_iupac_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WS → [AT][GC].`)
};

const es_iupac_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WS → [AT][GC].`)
};

const de_iupac_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WS → [AT][GC].`)
};

const nl_iupac_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WS → [AT][GC].`)
};

const fr_iupac_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WS → [AT][GC].`)
};

const it_iupac_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WS → [AT][GC].`)
};

const pt_br2_iupac_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WS → [AT][GC].`)
};

const pt_iupac_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WS → [AT][GC].`)
};

const ja_iupac_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WS → [AT][GC]。`)
};

const zh_iupac_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WS → [AT][GC]。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const iupac_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.iupac_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("iupac_ex3", locale)
	if (locale === "en") return en_iupac_ex3(inputs)
	if (locale === "es") return es_iupac_ex3(inputs)
	if (locale === "de") return de_iupac_ex3(inputs)
	if (locale === "nl") return nl_iupac_ex3(inputs)
	if (locale === "fr") return fr_iupac_ex3(inputs)
	if (locale === "it") return it_iupac_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_iupac_ex3(inputs)
	if (locale === "pt") return pt_iupac_ex3(inputs)
	if (locale === "ja") return ja_iupac_ex3(inputs)
	return zh_iupac_ex3(inputs)
};